export const TOGGLE_ORDER_CREATION_SIDEBAR_OPEN = 'orderCreationSidebar/TOGGLE_ORDER_CREATION_SIDEBAR_OPEN';

export interface ToggleWarehouseEmployeeTransportOrderCreationSidebarOpen {
    type: typeof TOGGLE_ORDER_CREATION_SIDEBAR_OPEN;
}

export type WarehouseEmployeeTransportOrderCreationSidebarActions =
    ToggleWarehouseEmployeeTransportOrderCreationSidebarOpen;
